import * as React from "react"

import { useAppDispatch, useAppSelector } from "../../../../../../hooks"
import { GlobalState } from "../../../../../../store"
import { collectionUrl } from "../../../../../../util/UrlGenerator"
import {
    itemSelector,
    collectionSelector,
} from "../../../../../resources/adapters"
import { fetchItem, fetchCollection } from "../../../../../resources/thunks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    label: string
    customLabel: string
    collectionId: number
    itemId: number
}

export const ItemInCollection = ({
    attributes,
    label,
    customLabel,
    collectionId,
    itemId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const item = itemSelector.selectById(resources, itemId)
    const collection = collectionSelector.selectById(resources, collectionId)

    React.useEffect(() => {
        if (!item) {
            dispatch(fetchItem(itemId))
        }
        if (!collection) {
            dispatch(fetchCollection(collectionId))
        }
    }, [])

    if (!item || !collection) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (item.doesExist && collection.doesExist) {
        const href = `${collectionUrl(collection)}/${item.id}`

        // we only show the item's title if there is no custom label
        const linkLabel = customLabel.length > 0 ? customLabel : item.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default ItemInCollection
